import * as getters from './getters';

import actions from './actions';
import mutations from './mutations';

const state = () => ({
  trendingIndices: null,
  trendingIndicesError: null,
  trendingIndicesLoading: false,
  trendingIndicesPage: 0,
  trendingIndicesPageSize: 5,
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
